import { STORAGE_KEY } from './STORAGE_KEY';

/**
 * Returns true if the auto-conversation experiment has already been fired
 * (checked via localStorage). This value is kept so that the
 * auto-conversation is never triggered again once it has fired.
 */
export const hasAutoConversationFired = (): boolean => {
	try {
		// eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
		return localStorage.getItem(STORAGE_KEY) === 'true';
	} catch {
		// localStorage unavailable — fail open (don't block)
		return false;
	}
};
